<template>
  <!-- 商城购买记录 -->
  <div class="category">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="query.uid" placeholder="请输入用户uid"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.name" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.qq_id" placeholder="请输入用户qq"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="query.user_name"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.shop_type" placeholder="商城类别">
          <el-option :value="undefined">全部</el-option>
          <el-option :value="1" label="csgo热门"></el-option>
          <el-option :value="2" label="csgo平价"></el-option>
          <el-option :value="3" label="dota商城"></el-option>
          <el-option :value="4" label="活动商城"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="query.state"
          multiple
          collapse-tags
          style="margin-left: 20px"
          placeholder="交易状态"
        >
          <el-option :value="1" label="待处理"></el-option>
          <el-option :value="2" label="处理通过"></el-option>
          <el-option :value="3" label="处理未通过"></el-option>
          <el-option :value="40" label="已发送"></el-option>
          <el-option :value="4" label="机器人报价中"></el-option>
          <el-option :value="5" label="报价成功"></el-option>
          <el-option :value="6" label="报价失败"></el-option>
          <el-option :value="11" label="在背包"></el-option>
          <el-option :value="12" label="已出售"></el-option>
          <el-option :value="13" label="取消中"></el-option>
          <el-option :value="31" label="扎比特等待发货"></el-option>
          <el-option :value="32" label="扎比特等待收货"></el-option>
          <el-option :value="33" label="扎比特交易成功"></el-option>
          <el-option :value="34" label="扎比特订单取消"></el-option>
          <el-option :value="35" label="扎比特购买失败"></el-option>
          <el-option :value="36" label="扎比特手动发货确认"></el-option>
          <el-option :value="50" label="IG订单取消"></el-option>
          <el-option :value="51" label="IG等待卖家发货"></el-option>
          <el-option :value="52" label="IG等待买家接收报价"></el-option>
          <el-option :value="53" label="IG交易成功"></el-option>
          <el-option :value="54" label="IG购买失败"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.pay_time_start"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择购买起始时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.pay_time_end"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择购买结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.get_goods_start"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择收货起始时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.get_goods_end"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择收货结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="query.order_no"
          placeholder="请输入第三方订单号"
        ></el-input>
      </el-form-item>
      <el-form-item title="按金额搜索">
        <el-button
          type="primary"
          :icon="souFlag?'el-icon-caret-right':'el-icon-caret-left'"
          @click="souFlag = !souFlag"
          ></el-button
        >
      </el-form-item>
      <el-form-item v-if="souFlag">
        <el-input
          v-model="query.cost_price_min"
          placeholder="用户购买最小金额"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="souFlag"> — </el-form-item>
      <el-form-item v-if="souFlag">
        <el-input
          v-model="query.cost_price_max"
          placeholder="用户购买最大金额"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="souFlag">
        <el-input
          v-model="query.pay_price_min"
          placeholder="第三方购买最小金额"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="souFlag"> — </el-form-item>
      <el-form-item v-if="souFlag">
        <el-input
          v-model="query.pay_price_max"
          placeholder="第三方购买最大金额"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button class="pull-right" type="primary" @click="handleSearch"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSelectedChange">同步状态</el-button>
      </el-form-item>
      <el-form-item>
        <p style="line-height: 32px">总金额：{{ amount }}</p>
      </el-form-item>
      <el-form-item>
        <p style="line-height: 32px">商品在背包金额：{{ backpack_amount }}</p>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="showWarningUser"
          :loading="warningUserDialog"
          >显示预警用户</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleBackpackExport"
          >导出背包订单</el-button
        >
      </el-form-item>
    </el-form>
    <el-form
      :model="exportInfo"
      :inline="true"
      ref="exportInfo"
      :rules="rule"
      class="demo-form-inline"
    >
      <el-form-item prop="start_time" label="时间区间：">
        <el-date-picker
          v-model="exportInfo.start_time"
          placeholder="开始时间"
          type="date"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        -
      </el-form-item>

      <el-form-item prop="end_time">
        <el-date-picker
          v-model="exportInfo.end_time"
          placeholder="结束时间"
          type="date"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-right: 30px" prop="type">
        <el-select v-model="exportInfo.type" placeholder="请选择类型">
          <el-option :value="1" label="取出表"></el-option>
          <el-option :value="3" label="商城表"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleExport" :loading="buttonLoading"
          >订单导出</el-button
        >
      </el-form-item>
    </el-form>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="name" label="物品名称">
          <template slot-scope="{ row }">
            <span
              >{{ row.name
              }}{{
                row.rarity ? "（" + getDotararity(row.rarity) + "）" : ""
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="物品暗金">
          <template slot-scope="{ row }">
            <p class="price" v-if="row.type === 1">普通</p>
            <p class="price" v-if="row.type === 2">StatTrak™</p>
            <p class="price" v-if="row.type === 3">纪念品</p>
            <p class="price" v-if="row.type === 4">★</p>
            <p class="price" v-if="row.type === 5">★StatTrak™</p>
          </template>
        </el-table-column>
        <el-table-column prop="uid" label="用户UID">
          <template slot-scope="{ row }">
            <span :style="row.is_red === 1 ? 'color:red;' : ''">{{
              row.uid
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_name" label="用户名">
          <template slot-scope="{ row }">
            <span :style="row.is_red === 1 ? 'color:red;' : ''">{{
              row.user_name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="backpack_id" label="背包id"></el-table-column>
        <el-table-column prop="prize_id" label="物品id"></el-table-column>
        <el-table-column prop="order_no" label="第三方订单号"></el-table-column>
        <el-table-column
          prop="cost_price"
          label="用户购买金额"
          v-if="GLOBAL.kefu_flag"
        ></el-table-column>
        <el-table-column prop="pay_price" label="第三方购买成本" v-if="GLOBAL.kefu_flag">
          <template slot-scope="{ row }">
            <span
              v-if="row.state != 36 && row.state != 11 && row.state != 12"
              >{{ row.pay_price }}</span
            >
            <span v-else>未购买</span>
          </template>
        </el-table-column>
        <el-table-column prop="profits" label="利润" v-if="GLOBAL.kefu_flag"></el-table-column>
        <el-table-column prop="delivery_type" label="发货类型">
          <template slot-scope="{ row }">
            <span v-if="row.delivery_type === 1">手动</span>
            <span v-if="row.delivery_type === 3">自动-ig手动</span>
            <span v-if="row.delivery_type === 4">自动-ig自动</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="交易状态">
          <template slot-scope="{ row }">
            <span v-if="row.state === 1">待处理</span>
            <span v-if="row.state === 2">处理通过</span>
            <span v-if="row.state === 3">处理未通过</span>
            <span v-if="row.state === 40">已发送</span>
            <span v-if="row.state === 4">机器人报价中</span>
            <span v-if="row.state === 5">报价成功</span>
            <span v-if="row.state === 6">报价失败</span>
            <span v-if="row.state === 11">在背包</span>
            <span v-if="row.state === 12">已出售</span>
            <span v-if="row.state === 13">取消中</span>
            <span v-if="row.state === 31">扎比特等待发货</span>
            <span v-if="row.state === 32">扎比特等待收货</span>
            <span v-if="row.state === 33">扎比特交易成功</span>
            <span v-if="row.state === 34">扎比特订单取消</span>
            <span v-if="row.state === 35">扎比特购买失败</span>
            <span v-if="row.state === 36">扎比特手动发货确认</span>
            <span v-if="row.state === 50">IG订单取消</span>
            <span v-if="row.state === 51">IG等待卖家发货</span>
            <span v-if="row.state === 52">IG等待买家接收报价</span>
            <span v-if="row.state === 53">IG交易成功</span>
            <span v-if="row.state === 54">IG购买失败</span>
            <span v-if="row.state === 80">锁定中</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="交易时间"></el-table-column>
        <el-table-column prop="updated_at" label="收货时间"></el-table-column>
        <el-table-column prop="failure" label="自动发货失败原因">
          <template slot-scope="{ row }">
            <span>{{ row.failure ? row.failure : "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="transaction_url" label="交易链接" width="150px">
          <template slot-scope="{ row }">
            <span>{{ row.transaction_url ? row.transaction_url : "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易日志" width="120px">
          <template slot-scope="{ row }">
            <el-row>
              <el-button type="primary" @click="handleHistory(row.id)"
                >记录</el-button
              >
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
      ></el-pagination>
      <el-dialog
        :visible.sync="visible"
        title="交易日志记录"
        width="800px"
        :close-on-click-modal="false"
      >
        <el-table :data="logData" v-loading="loading">
          <el-table-column prop="created_at" label="操作时间"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="{ row }">
              <span v-if="row.state === 1">待处理</span>
              <span v-if="row.state === 2">处理通过</span>
              <span v-if="row.state === 3">处理未通过</span>
              <span v-if="row.state === 40">已发送</span>
              <span v-if="row.state === 31">扎比特等待发货</span>
              <span v-if="row.state === 32">扎比特等待收货</span>
              <span v-if="row.state === 33">扎比特交易成功</span>
              <span v-if="row.state === 34">扎比特订单取消</span>
              <span v-if="row.state === 4">机器人报价中</span>
              <span v-if="row.state === 5">报价成功</span>
              <span v-if="row.state === 6">报价失败</span>
              <span v-if="row.state === 11">在背包</span>
              <span v-if="row.state === 12">已出售</span>
              <span v-if="row.state === 13">取消中</span>
              <span v-if="row.state === 34">订单取消或订单失败</span>
              <span v-if="row.state === 35">扎比特购买失败</span>
              <span v-if="row.state === 36">扎比特手动发货确认</span>
              <span v-if="row.state === 50">IG订单取消</span>
              <span v-if="row.state === 51">IG等待卖家发货</span>
              <span v-if="row.state === 52">IG等待买家接收报价</span>
              <span v-if="row.state === 53">IG交易成功</span>
              <span v-if="row.state === 54">IG购买失败</span>
              <span v-if="row.state === 80">锁定中</span>
              <span v-if="row.state === 110">用户购买</span>
              <span v-if="row.state === 111">商品IG手动下单</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="{ row }">
              <span>{{ row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :total="logDataMeta ? logDataMeta.total : 0"
          :current-page="logDataMeta ? logDataMeta.current_page : 1"
          :page-size="logDataMeta ? logDataMeta.per_page : 15"
          @current-change="handlLogPageChange"
        ></el-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import rarityList from '@/assets/js/rarityList'//dota稀有度
import http, { getData, postData, patchData, server, api, postApiData, patchApiData, getApiData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  data() {
    return {
      buttonLoading: false,//按钮动画
      souFlag: false,//按金额搜索显示标志
      warningUserDialog: false,//显示预警用户加载按钮动画
      logData: undefined,
      logDataMeta: {},
      query: {
        page: 1,
        uid: undefined,
        name: undefined,
        user_name: undefined,
        qq_id: undefined,
        state: undefined,
        pay_time_start: undefined,
        pay_time_end: undefined,
        get_goods_start: undefined,
        get_goods_end: undefined,
        order_no: undefined,
        shop_type: undefined,
        cost_price_min: undefined,
        cost_price_max: undefined,
        pay_price_min: undefined,
        pay_price_max: undefined,
      },
      exportInfo: {//导出传递的信息
        type: 1,//导出表的类型 1是取出 3商城
        start_time: undefined,//开始时间
        end_time: undefined,//结束时间
      },
      rarityList: rarityList,//dota稀有度
      dataList: undefined,//列表数据
      amount: '',//总金额
      backpack_amount: '',//商品在背包金额
      log: {
        id: undefined,
        page: 1,
      },
      loading: false,
      visible: false,
      params_sub: undefined,
      dataMeta: {},
      rule: {//表单验证
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }
        ],
        start_time: [
          {
            required: true,
            message: '请选择开始时间',
            trigger: 'blur'
          }
        ],
        end_time: [
          {
            required: true,
            message: '请选择结束时间',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  watch: {
    visible(val) {
      // 如果弹窗关闭还原id和分页下标
      if (!val) {
        this.log.id = undefined
        this.log.page = 1
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    showWarningUser() {
      //将预警用户的信息标红
      this.warningUserDialog = true
      let params = {
        record_type: 'shop_order'
      }
      getApiData('user_warning', params)
        .then(res => {
          this.getData()
        }).finally(() => {
          this.warningUserDialog = false
        })
    },
    handleSelectedChange() {
      getApiData(`shop_synchronous`)
        .then(res => {
          this.$message.success('操作成功')
        })
        .finally(() => {
        })
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      this.params_sub = {
        page: this.query.page,
        name: this.query.name,
        user_name: this.query.user_name,
        uid: this.query.uid,
        qq_id: this.query.qq_id,
        state: this.query.state,
        pay_time_start: this.query.pay_time_start,
        pay_time_end: this.query.pay_time_end,
        get_goods_start: this.query.get_goods_start,
        get_goods_end: this.query.get_goods_end,
        order_no: this.query.order_no,
        shop_type: this.query.shop_type,
        cost_price_min: this.query.cost_price_min,
        cost_price_max: this.query.cost_price_max,
        pay_price_min: this.query.pay_price_min,
        pay_price_max: this.query.pay_price_max,
      }
      getApiData(`shop_records`, this.params_sub)
        .then(res => {
          this.dataList = res.data
          this.amount = res.amount
          this.backpack_amount = res.backpack_amount
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleHistory(id) {
      this.visible = true
      this.log.id = id
      this.getLogData()
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    handlLogPageChange(page) {
      this.log.page = page
      this.getLogData()
    },
    getLogData() {
      getApiData(`shop_record/${this.log.id}`, { page: this.log.page })
        .then(res => {
          this.logData = res.data
          this.logDataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDotararity(num) {
      //匹配dota的稀有度
      for (let item of this.rarityList) {
        if (item.val === num) {
          return item.text
        }
      }
      return '无'
    },
    handleExport() {
      this.$refs['exportInfo'].validate((valid) => {
        if (valid) {
          let params = this.exportInfo
          this.buttonLoading = true

          http
            .post(
              api + 'shop_record_export',
              { ...params },
              {
                responseType: 'arraybuffer'
              }
            )
            .then(res => {
              if (res) {
                saveFile(res, {
                  type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  name: `${this.exportInfo.type === 1 ? '取出' : '商城'}订单记录.xlsx`
                })
              }
            }).finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    handleBackpackExport() {
      let params = this.query

      http
        .post(
          api + 'shop_backpack_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          if (res) {
            saveFile(res, {
              type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              name: '商品在背包订单.xlsx'
            })
          }
        }).finally(() => {
        })
    },
  }
}
</script>

<style lang="less">
.table-image {
  max-height: 100px;
  max-width: 100px;
}

.avatar-uploader {
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
